import { hasBooleanProperty } from "common/reducers/UtilsTypes";
import { Nullable } from "common/types";
import { List, Record } from "immutable";

export const pricePresentationSlideFromJSON = (
  json: Partial<IPricePresentationSlideData>,
): PricePresentationSlideRecord => {
  const recordData: IPricePresentationSlideRecord = { ...(json as any) };

  if (json.discount_ids) {
    recordData.discount_ids = List(json.discount_ids);
  }

  return new PricePresentationSlideRecord(recordData);
};

export const pricePresentationSlideToJSON = (record: PricePresentationSlideRecord) => {
  const json = record.toJS() as Partial<IPricePresentationSlideData>;

  return json;
};

export const isSlideEnabled = (slide: unknown): boolean => {
  if (typeof slide !== "object" || !slide) {
    return false;
  }

  if (slide instanceof PricePresentationSlideRecord) {
    return slide.get("enabled", false);
  }

  if (hasBooleanProperty(slide, "enabled")) {
    return slide.enabled;
  }

  return false;
};

export interface IPricePresentationSlideData {
  discount_id?: number[];
  discount_ids?: number[];
  enabled?: boolean;
  payment_term_id?: Nullable<number>;
  title?: string;
}

export interface IPricePresentationSlideRecord {
  discount_id: Nullable<number>;
  discount_ids: List<number>;
  enabled: boolean;
  payment_term_id: Nullable<number>;
  title: string;
}

export const defaultPricePresentationSlide: IPricePresentationSlideRecord = {
  discount_id: null,
  discount_ids: List(),
  enabled: false,
  payment_term_id: null,
  title: "",
};

export class PricePresentationSlideRecord
  extends Record(defaultPricePresentationSlide)
  implements IPricePresentationSlideRecord {}
